module.exports = __webpack_public_path__ + "static/media/desktop_unsafecars_banner.02bb9705.png";